import { render, staticRenderFns } from "./PhotovoltaicReturnCard.vue?vue&type=template&id=9891aea8"
import script from "./PhotovoltaicReturnCard.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicReturnCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports